import React, { useEffect } from 'react';
import AllRoute from '../router'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { supabase } from '../../config/supabase';
import { loadCatalogPriceOverrides } from '../../data/catalogOverrides';


const App = () => {
  // Apply staff-saved hardware catalog price overrides onto the in-memory
  // catalog arrays once per app load, before any pricing surface is likely
  // to have mounted (routes are lazy-loaded). Fire-and-forget: a failure
  // just leaves the hardcoded catalog prices in place.
  useEffect(() => {
    loadCatalogPriceOverrides(supabase).catch((err) => console.error('Failed to load catalog price overrides', err));
  }, []);

  return (
    <div className="App" id='scrool'>
      <AllRoute />
      <ToastContainer />
    </div>
  );
}

export default App;